import IndividualRepetitionIntervalDrawer from '@/domain/termine/features/UpdateTermin/Mobile/components/IndividualRepetitionIntervalDrawer';
import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared/types';
import { TerminWiederholungsIntervall } from '@/domain/termine/shared/types';
import { Field } from '@e2n/ui';

export function RepeatIntervalSelectFormField({
  className,
  form,
}: UpdateTermineFormProps) {
  const validIntervals = new Set<string>(
    Object.values(TerminWiederholungsIntervall),
  );

  function isInterval(value: unknown): value is TerminWiederholungsIntervall {
    return typeof value === 'string' && validIntervals.has(value);
  }

  return (
    <div className={`flex flex-col gap-4 w-2/3 ${className}`}>
      <form.Field name="wiederholungsIntervall">
        {(field) => {
          const intervalValue = isInterval(field.state.value)
            ? field.state.value
            : TerminWiederholungsIntervall.TAG;

          return (
            <Field className="flex flex-col w-full gap-1">
              <IndividualRepetitionIntervalDrawer
                value={intervalValue}
                onChange={field.handleChange}
                form={form}
              />
            </Field>
          );
        }}
      </form.Field>
    </div>
  );
}
